import gql from "graphql-tag";

export const CREATE_VISITOR_BILLING_ACCOUNT = gql`
  mutation ($input: visitorBillingAccountInput) {
    createVisitorBillingAccount(input: $input)
  }
`;
